<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs :pt-5="$vuetify.breakpoint.lgAndUp">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap justify-center align-center pt-5 pb-10>
            <v-flex xs11 lg11>
              <v-card class="rounded-lg">
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12 lg12 ma-0 pa-0>
                    <v-stepper v-model="StepperStatus" class="elevation-0">
                      <v-stepper-header class="elevation-0">
                        <v-stepper-step
                          color="#077893"
                          :complete="StepperStatus > 1"
                          step="1"
                        >
                          ข้อมูลองค์กร
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step
                          color="#077893"
                          :complete="StepperStatus > 2"
                          step="2"
                        >
                          ข้อมูลส่วนตัว
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step
                          color="#077893"
                          :complete="StepperStatus > 3"
                          step="3"
                        >
                          รายละเอียดข้อมูล
                        </v-stepper-step>
                      </v-stepper-header>
                      <v-stepper-items>
                        <v-stepper-content step="1">
                          <v-card class="mb-8" outlined>
                            <v-card-text>
                              <b class="mr-2">นโยบาย :</b>
                              <span>{{ PolicyHeader }} </span>
                              <br />
                              <b>องค์กรที่ขอความยินยอม :</b>
                              {{ BusinessNameTh }}
                              <br />
                              <b>ข้อมูลที่ต้องการขอ </b>
                              <v-chip
                                small
                                style="border: 1px solid"
                                v-for="(item, i) in itemsRequest"
                                :key="i"
                                class="ma-1"
                                label
                                text-color="#077893"
                                color="#ddf7ff"
                              >
                                <b>{{ item }}</b>
                              </v-chip>
                              <br /><br />
                              <v-divider></v-divider>
                              <h2 class="mt-5 mb-3">รายละเอียดนโยบาย</h2>
                              <div v-html="PolicyDetail"></div>
                              <v-divider></v-divider>
                              <div
                                v-for="(item, index) in Consent"
                                :key="index"
                                class="mt-6"
                              >
                                <h2>
                                  {{ index + 1 }}. {{ item.ConsentHeader }}
                                </h2>
                                <div class="mt-4 mb-1">
                                  <h3>รายละเอียดยินยอม</h3>
                                </div>
                                <span v-html="item.ConsentDetail"></span>
                                <div class="mt-4 mb-1">
                                  <h3>รายละเอียดไม่ยินยอม</h3>
                                </div>
                                <span v-html="item.RejectReason"></span>
                                <v-flex xs10 lg3>
                                  <v-radio-group
                                    v-model="item.Status"
                                    row
                                    :rules="[
                                      (v) => !!v || 'กรุณาเลือก ความยินยอม',
                                    ]"
                                  >
                                    <v-radio
                                      label="ยินยอม"
                                      value="approve"
                                    ></v-radio>
                                    <v-divider vertical></v-divider>
                                    <v-radio
                                      class="ml-5"
                                      label="ไม่ยินยอม"
                                      value="unapprove"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-flex>
                              </div>
                            </v-card-text>
                          </v-card>
                          <v-layout row wrap justify-end>
                            <v-flex xs8 sm8 md2 lg2>
                              <v-btn
                                block
                                dark
                                color="#077893"
                                @click="StepperStatus = 2"
                              >
                                ถัดไป
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                          <v-card outlined class="mb-8">
                            <v-card-text>
                              <v-layout
                                row
                                wrap
                                justify-center
                                align-center
                                pt-3
                              >
                                <v-flex xs11 sm11 md5 lg6 pa-2>
                                  <v-text-field
                                    label="ชื่อ"
                                    v-model="InputName"
                                    append-icon="mdi-account-outline"
                                    :rules="[(v) => !!v || 'กรุณากรอกชื่อ']"
                                    dense
                                    solo
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs11 sm11 md5 lg4 pa-2>
                                  <v-text-field
                                    label="เบอร์โทร"
                                    v-model="InputTel"
                                    append-icon="mdi-phone-outline"
                                    dense
                                    solo
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs11 sm11 md10 lg10 pa-2>
                                  <v-text-field
                                    label="อีเมล"
                                    append-icon="mdi-email-outline"
                                    v-model="InputEmail"
                                    dense
                                    solo
                                  ></v-text-field>
                                </v-flex>
                              </v-layout> </v-card-text
                          ></v-card>
                          <v-layout row wrap justify-end>
                            <v-flex xs8 sm8 md2 lg2>
                              <v-btn
                                block
                                dark
                                color="#077893"
                                @click="StepperStatus = 3"
                              >
                                ถัดไป
                              </v-btn>
                            </v-flex>
                            <v-flex
                              xs8
                              sm8
                              md2
                              lg2
                              :ml-7="$vuetify.breakpoint.lgAndUp"
                              :pt-3="$vuetify.breakpoint.smAndDown"
                            >
                              <v-btn
                                block
                                dark
                                outlined
                                color="#077893"
                                @click="StepperStatus = 1"
                              >
                                ย้อนกลับ
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-stepper-content>
                        <v-stepper-content step="3">
                          <v-card outlined class="mb-8">
                            <v-card-text>
                              <v-layout
                                row
                                wrap
                                justify-center
                                align-center
                                pt-3
                              >
                                <v-flex xs11 sm11 md10 lg10 pa-2>
                                  <h2 class="mb-2">รายละเอียดข้อมูล</h2>
                                  <b>ชื่อ</b> {{ InputName || "-" }} <br />
                                  <b>เบอร์โทร</b> {{ InputTel || "-" }} <br />
                                  <b>อีเมล</b> {{ InputEmail || "-" }} <br />

                                  <b class="mr-2">นโยบาย :</b>
                                  <span>{{ PolicyHeader }} </span>
                                  <br />
                                  <b>องค์กรที่ขอความยินยอม :</b>
                                  {{ BusinessNameTh }}
                                  <br />
                                  <b>ข้อมูลที่ต้องการขอ </b>
                                  <v-chip
                                    small
                                    style="border: 1px solid"
                                    v-for="(item, i) in itemsRequest"
                                    :key="i"
                                    class="ma-1"
                                    label
                                    text-color="#077893"
                                    color="#ddf7ff"
                                  >
                                    <b>{{ item }}</b>
                                  </v-chip>
                                  <br /><br />
                                  <b>รายละเอียดนโยบาย</b>
                                  <div v-html="PolicyDetail"></div>
                                  <div
                                    v-for="(item, index) in Consent"
                                    :key="index"
                                    class="mt-6"
                                  >
                                    <h2>
                                      {{ index + 1 }}. {{ item.ConsentHeader }}
                                    </h2>
                                    <div class="mt-4 mb-1">
                                      <h3>รายละเอียดยินยอม</h3>
                                    </div>
                                    <span v-html="item.ConsentDetail"></span>
                                    <div class="mt-4 mb-1">
                                      <h3>รายละเอียดไม่ยินยอม</h3>
                                    </div>
                                    <span v-html="item.RejectReason"></span>
                                    <br />
                                    <b class="mr-4">สถานะ</b>
                                    <v-chip
                                      color="green"
                                      dark
                                      v-if="item.Status === 'approve'"
                                      >ยินยอม</v-chip
                                    >
                                    <v-chip
                                      color="error"
                                      dark
                                      v-else-if="item.Status === 'unapprove'"
                                      >ไม่ยินยอม</v-chip
                                    >
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-card-text></v-card
                          >
                          <v-layout
                            row
                            wrap
                            justify-end
                            align-end
                            v-if="NameBtnSave === 'ยืนยันตัวเลือกของฉัน'"
                          >
                            <v-flex xs8 sm8 md2 lg2>
                              <v-btn
                                block
                                color="#077893"
                                dark
                                @click="Fn_Save"
                              >
                                {{ NameBtnSave }}</v-btn
                              >
                            </v-flex>
                            <v-flex
                              xs8
                              sm8
                              md2
                              lg2
                              :ml-7="$vuetify.breakpoint.lgAndUp"
                              :pt-3="$vuetify.breakpoint.smAndDown"
                            >
                              <v-btn
                                color="#077893"
                                outlined
                                block
                                @click="StepperStatus = 2"
                                >ย้อนกลับ</v-btn
                              >
                            </v-flex>
                          </v-layout>
                          <v-layout
                            row
                            wrap
                            justify-center
                            align-self-center
                            pb-4
                            v-else
                          >
                            <v-flex xs11 sm10 md4 lg4>
                              <v-alert
                                outlined
                                type="success"
                                text
                              >
                                {{ NameBtnSave }}
                              </v-alert>
                            </v-flex>
                          </v-layout>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-stepper>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-container>
      <v-overlay :value="loadingDownloadData">
        <img
          width="100"
          :src="require('@/assets/img/magnifier-zoom-search.gif')"
        />
        <div class="text-center">กำลังดาวน์โหลดข้อมูล...</div>
      </v-overlay>
    </v-main>
  </v-app>
</template>

<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  data: function () {
    return {
      valid: true,
      Consent: [],
      DataMessage: [],
      DataConsentStatus: [],
      StepperStatus: 1,
      Detail: "",
      PolicyHeader: "นโยบายวันนี้",
      PolicyName: "บริษัท วัน อิเล็กทรอนิกส์ บิลลิ่ง จำกัด",
      PolicyDetail: "",
      BusinessNameTh: "",
      AccessToken: "",
      Status: "",
      InputName: "",
      InputTel: "",
      InputEmail: "",
      loadingDownloadData: false,
      NameBtnSave: "ยืนยันตัวเลือกของฉัน",
      itemsRequest: [],
    };
  },
  computed: {},
  mounted() {
    this.Fn_getDataConsent();
  },
  methods: {
    async Fn_getDataConsent() {
      this.loadingDownloadData = true;
      this.axios
        .get(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "qrcode/GetQrcodeConsent/" +
            this.$route.path.split("/")[3]
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.DataMessage = response.data.Message;
            this.GroupName = response.data.Message.GroupName;
            this.Consent = response.data.Message.Consent;
            this.PolicyName = response.data.Message.Name;
            this.PolicyHeader = response.data.Message.Policy.PolicyHeader;
            this.PolicyDetail = response.data.Message.Policy.PolicyDetail;
            this.BusinessNameTh = response.data.Message.BusinessNameTh;
            this.Status = response.data.Message.Consent[0].Status;
            var FixArray = response.data.Message.Tag;
            this.itemsRequest = FixArray.split(",").map((item) => item.trim());
          } else {
            window.close();
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          window.close();
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_Save() {
      if (this.$refs.form.validate()) {
        for (var i = 0; i < this.Consent.length; i++) {
          var x = {
            ConsentId: this.Consent[i].ConsentId,
            Status: this.Consent[i].Status,
          };
          this.DataConsentStatus.push(x);
        }
        var payload = {
          BusinessId: this.DataMessage.BusinessId,
          QrcodeId: this.DataMessage.QrcodeId,
          GroupId: this.DataMessage.GroupId || "",
          Consent: this.DataConsentStatus,
          PolicyId: this.DataMessage.Policy.PolicyId,
          Name: this.InputName,
          Tel: this.InputTel,
          Email: this.InputEmail,
        };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "qrcode/ConfirmQrcodeConsent",
            payload
          )
          .then((response) => {
            this.loadingDownloadData = false;

            if (response.data.Status === "OK") {
              Toast.fire({
                icon: "success",
                title: "ยืนยันข้อมูลเรียบร้อย",
              });
              this.NameBtnSave = "คุณได้บันทึกรายการเรียบร้อยแล้ว";
              this.InputName = "";
              this.InputEmail = "";
              this.InputTel = "";
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.loadingDownloadData = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    Fn_Cancle() {
      window.close();
      this.$refs.formData.reset();
    },
  },
  watch: {},
};
</script>

<style scoped>
b,
h3 {
  color: black;
}
.bg-color {
  background-color: #ddf7ff;
}

.bg-card {
  background-color: #eeeeee;
}
</style>
